import { Box, Typography } from "@bca/ui-library";
import React from "react";

import ContactSupport from "../Options/ContactSupport";

const NoTransport = ({
  callCustomerServiceOnClickHandler = () => {},
  emailCustomerServiceOnClickHandler = () => {},
}) => {
  return (
    <Box>
      <Typography fontSize="body-medium">
        This vehicle does not currently qualify for online transport bookings.
      </Typography>
      <Typography fontWeight="bold" marginTop={8} marginBottom={4}>
        Please get in touch to discuss your options
      </Typography>
      <ContactSupport
        callCustomerServiceOnClickHandler={callCustomerServiceOnClickHandler}
        emailCustomerServiceOnClickHandler={emailCustomerServiceOnClickHandler}
      />
    </Box>
  );
};

export default NoTransport;
